import { render, staticRenderFns } from "./RichInputToolbar.vue?vue&type=template&id=350bdc40&"
import script from "./RichInputToolbar.vue?vue&type=script&lang=js&"
export * from "./RichInputToolbar.vue?vue&type=script&lang=js&"
import style0 from "./RichInputToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports